(function () {
  function qsAll(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function parseJSONSafe(txt) {
    try { return JSON.parse(txt); } catch (e) { return null; }
  }

  function getVariantMap() {
    var s = document.querySelector('script[data-variant-map]');
    if (!s) return null;
    return parseJSONSafe(s.textContent);
  }

  function getSelectedOptions() {
    var checked = qsAll('input[type="radio"][data-variant-input]:checked');
    checked.sort(function (a, b) {
      var ai = parseInt(String(a.getAttribute('data-index') || '').replace('option', ''), 10);
      var bi = parseInt(String(b.getAttribute('data-index') || '').replace('option', ''), 10);
      return (ai || 999) - (bi || 999);
    });
    return checked.map(function (el) { return el.value; });
  }

  function findVariantId(map, selected) {
    if (!map || !map.length) return null;
    if (!selected || !selected.length) return null;

    for (var i = 0; i < map.length; i++) {
      var v = map[i];
      if (!v || !v.options) continue;

      var ok = true;
      for (var j = 0; j < selected.length; j++) {
        if (v.options[j] !== selected[j]) { ok = false; break; }
      }
      if (ok) return String(v.id);
    }
    return null;
  }

  function computeCorrectVariantId() {
    var map = getVariantMap();
    if (!map) return null;
    var selected = getSelectedOptions();
    return findVariantId(map, selected);
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return url.indexOf('/cart/add') !== -1;
  }

  function patchFormData(fd, variantId) {
    if (!variantId || !fd) return fd;

    // Shopify aceita tanto 'id' quanto items[0][id] dependendo do fluxo
    if (fd.has('id')) fd.set('id', variantId);
    if (fd.has('items[0][id]')) fd.set('items[0][id]', variantId);

    // Alguns fluxos usam items[][id] ou items[0].id (raros)
    if (fd.has('items[][id]')) fd.set('items[][id]', variantId);

    return fd;
  }

  function patchUrlEncoded(bodyStr, variantId) {
    if (!variantId || typeof bodyStr !== 'string') return bodyStr;

    var params = new URLSearchParams(bodyStr);
    if (params.has('id')) params.set('id', variantId);
    if (params.has('items[0][id]')) params.set('items[0][id]', variantId);
    if (params.has('items[][id]')) params.set('items[][id]', variantId);

    return params.toString();
  }

  function patchJsonBody(bodyStr, variantId) {
    if (!variantId || typeof bodyStr !== 'string') return bodyStr;

    var obj = parseJSONSafe(bodyStr);
    if (!obj) return bodyStr;

    // formatos comuns: {id: 123} ou {items:[{id:123,quantity:1}]}
    if (obj.id) obj.id = Number(variantId);
    if (Array.isArray(obj.items) && obj.items[0] && obj.items[0].id) obj.items[0].id = Number(variantId);

    try { return JSON.stringify(obj); } catch (e) { return bodyStr; }
  }

  // --- PATCH FETCH ---
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var req = input instanceof Request ? input : null;
        var url = req ? req.url : (typeof input === 'string' ? input : '');

        if (!isCartAddUrl(url)) return _fetch.apply(this, arguments);

        var variantId = computeCorrectVariantId();
        if (!variantId) return _fetch.apply(this, arguments);

        // Normaliza init
        init = init || {};
        var method = (init.method || (req && req.method) || 'GET').toUpperCase();
        if (method === 'GET') return _fetch.apply(this, arguments);

        var body = init.body || (req && req.body) || null;

        // Se for Request, precisamos clonar para ler/reescrever body
        if (req && !init.body) {
          // Clona e lê como arrayBuffer/text via req.clone().text() é async.
          // Para não transformar isso num async gigante, só patchamos quando init.body existir.
          // (No Impulse, normalmente fetch passa init.body direto.)
          return _fetch.apply(this, arguments);
        }

        // Patch body
        if (body instanceof FormData) {
          patchFormData(body, variantId);
          init.body = body;
        } else if (typeof body === 'string') {
          // tenta detectar json
          var ct = '';
          if (init.headers) {
            if (init.headers.get) ct = init.headers.get('content-type') || '';
            else if (typeof init.headers === 'object') ct = init.headers['Content-Type'] || init.headers['content-type'] || '';
          }
          if (ct.indexOf('application/json') !== -1 || body.trim().charAt(0) === '{') {
            init.body = patchJsonBody(body, variantId);
          } else {
            init.body = patchUrlEncoded(body, variantId);
          }
        }

        return _fetch.call(this, input, init);
      } catch (e) {
        return _fetch.apply(this, arguments);
      }
    };
  }

  // --- PATCH XHR ---
  var XHROpen = XMLHttpRequest.prototype.open;
  var XHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartAddUrl = url;
    return XHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (isCartAddUrl(this.__cartAddUrl)) {
        var variantId = computeCorrectVariantId();
        if (variantId) {
          if (body instanceof FormData) {
            patchFormData(body, variantId);
          } else if (typeof body === 'string') {
            body = patchUrlEncoded(body, variantId);
          }
        }
      }
    } catch (e) {}
    return XHRSend.call(this, body);
  };
})();
